import { render, staticRenderFns } from "./AppFab.vue?vue&type=template&id=23640754&"
import script from "./AppFab.vue?vue&type=script&lang=js&"
export * from "./AppFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFabTransition,VIcon})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})


/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23640754')) {
      api.createRecord('23640754', component.options)
    } else {
      api.reload('23640754', component.options)
    }
    module.hot.accept("./AppFab.vue?vue&type=template&id=23640754&", function () {
      api.rerender('23640754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppFab.vue"
export default component.exports